import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = ({ links, onLinkClick, activeTab }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visibleLinks, setVisibleLinks] = useState([]); // To store the visible set of links
  const [startIndex, setStartIndex] = useState(0); // To track the starting index for visible links
  const [maxVisible, setMaxVisible] = useState(4); // Default to 4 visible links


  // Adjust the number of visible links based on the window size
  const updateVisibleLinks = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth > 1024) {
      setMaxVisible(5); // Show 5 links on larger screens
    } else if (windowWidth > 768) {
      setMaxVisible(4); // Show 4 links on medium screens
    } else {
      setMaxVisible(3); // Show 3 links on smaller screens
    }
  };

  useEffect(() => {
    // Initialize the number of visible links based on the screen size
    updateVisibleLinks();
    window.addEventListener("resize", updateVisibleLinks);

    // Cleanup the event listener on unmount
    return () => window.removeEventListener("resize", updateVisibleLinks);
  }, []);

  // Update the visible set of links whenever startIndex or maxVisible changes
  useEffect(() => {
    setVisibleLinks(links.slice(startIndex, startIndex + maxVisible));
  }, [startIndex, maxVisible, links]);

  const dashboardRoutes = [
    "/hero-dashboard/users",
    "/hero-dashboard/suppliers",
    "/hero-dashboard/unity-learning",
    "/hero-dashboard/learner-applicants-dashboard",
    "/hero-dashboard/intake-block",
    "/hero-dashboard/job-applicant-explore",
    "/hero-dashboard/review-applicants-onedashtpxKKlw",
    "/hero-dashboard/facilitators",
  ];

  // Find the current dashboard page index
  const dashboardIndex = dashboardRoutes.findIndex(route => location.pathname.startsWith(route));

  // Handle the left navigation button click: go to previous dashboard page
  const handleLeftClick = () => {
    if (dashboardIndex > 0) {
      navigate(dashboardRoutes[dashboardIndex - 1]);
    }
  };

  // Handle the right navigation button click: go to next dashboard page
  const handleRightClick = () => {
    if (dashboardIndex < dashboardRoutes.length - 1) {
      navigate(dashboardRoutes[dashboardIndex + 1]);
    }
  };

  // Navigate to route when a nav item is clicked
  const handleNavClick = (link) => {
    navigate(link);
  };

  return (
    <nav className="hero-system-navbar">
      {/* Left navigation button */}
      <button className="nav-button left" onClick={handleLeftClick} disabled={dashboardIndex <= 0}>
        &#8592;
      </button>

      <ul className="hero-system-navbar-list">
        {visibleLinks.map((link) => (
          <li
            key={link}
            className={`hero-system-navbar-item ${
              activeTab === link ? "active" : ""
            }`}
            onClick={() => onLinkClick(link)}
          >
            {link}
          </li>
        ))}
      </ul>

      {/* Right navigation button */}
      <button className="nav-button right" onClick={handleRightClick} disabled={dashboardIndex >= dashboardRoutes.length - 1}>
        &#8594;
      </button>
    </nav>
  );
};

export default Navbar;
